import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "left-card space-y-6 p-4 bg-white rounded-xl" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-wrap gap-1 my-1"
}
const _hoisted_5 = {
  key: 1,
  class: "text-gray-lp-600"
}
const _hoisted_6 = { class: "w-full rounded-lg border border-b-0 border-gray-lp-1500 my-2 overflow-hidden" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "bg-gray-lp-2800 font-semibold text-xs" }, [
    /*#__PURE__*/_createVNode("th", { class: "py-4 px-3 text-left w-1/20" }, " No "),
    /*#__PURE__*/_createVNode("th", { class: "py-4 px-3 text-left w-3/20" }, " Negara tujuan "),
    /*#__PURE__*/_createVNode("th", { class: "py-4 px-3 text-left w-3/20" }, " Min. harga barang "),
    /*#__PURE__*/_createVNode("th", { class: "py-4 px-3 text-left w-3/20" }, " Maks. harga barang "),
    /*#__PURE__*/_createVNode("th", { class: "py-4 px-3 text-left w-3/20" }, " Min. biaya COD "),
    /*#__PURE__*/_createVNode("th", { class: "py-4 px-3 text-left w-3/20" }, " Komisi COD POS Tujuan ")
  ])
], -1)
const _hoisted_9 = { class: "py-4 px-3 text-left w-1/20" }
const _hoisted_10 = { class: "py-4 px-3 text-left w-3/20" }
const _hoisted_11 = { class: "py-4 px-3 text-left w-3/20" }
const _hoisted_12 = { class: "py-4 px-3 text-left w-3/20" }
const _hoisted_13 = { class: "py-4 px-3 text-left w-3/20" }
const _hoisted_14 = { class: "py-4 px-3 text-left w-3/20" }
const _hoisted_15 = { class: "rounded-xl ml-4 p-4 bg-white space-y-4" }
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-black-lp-100" }, "Tanggal Dibuat", -1)
const _hoisted_18 = { class: "font-semibold text-black-lp-100" }
const _hoisted_19 = { class: "font-semibold text-gray-lp-800" }
const _hoisted_20 = { class: "flex flex-col gap-1" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-black-lp-100" }, "Tanggal Diperbarui", -1)
const _hoisted_22 = { class: "font-semibold text-black-lp-100" }
const _hoisted_23 = { class: "font-semibold text-gray-lp-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    customClass: "detail-cod-international",
    onBack: _ctx.goBack,
    title: _ctx.getTitle,
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.getDetail,
    "vertical-separator": false,
    noPaddingSubData: true,
    "use-padding-vertical": "",
    headerNewLayout: ""
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            label: "ID Konfigurasi",
            fontStyleLabel: "font-normal text-black-lp-100",
            customStyleValue: "my-1 font-semibold",
            value: _ctx.detailData.ccoId
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            label: "Nama Konfigurasi",
            fontStyleLabel: "font-normal text-black-lp-100",
            customStyleValue: "my-1 font-semibold",
            value: _ctx.$t(_ctx.detailData.ccoName)
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            label: "Deskripsi Konfigurasi",
            fontStyleLabel: "font-normal text-black-lp-100",
            customStyleValue: "my-1 font-semibold",
            value: _ctx.detailData.ccoDescription
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            fontStyleLabel: "font-normal text-black-lp-100",
            label: "Jenis Pengiriman"
          }, {
            default: _withCtx(() => [
              (_ctx.productType.length)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productType, (product, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: "flex flex-row gap-1"
                      }, [
                        _createVNode(_component_ChipsV2, {
                          label: product,
                          boldText: false
                        }, null, 8, ["label"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("span", _hoisted_5, "-"))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_DataWrapper, {
          label: "Konfigurasi COD",
          fontStyleLabel: "font-normal text-black-lp-100"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode("table", _hoisted_7, [
                _hoisted_8,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.countries, (country, index) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: index,
                      class: "font-normal text-xs border-t border-b border-gray-lp-1500"
                    }, [
                      _createVNode("td", _hoisted_9, _toDisplayString(index + 1), 1),
                      _createVNode("td", _hoisted_10, _toDisplayString(country.countryName) + " " + _toDisplayString(country.countryCode ? ` (${country.countryCode})` : ""), 1),
                      _createVNode("td", _hoisted_11, _toDisplayString(country.currencyCode) + " " + _toDisplayString(_ctx.formatItemPrice(
                        Number(country.minPrice),
                        country.currencyCode === "IDR" ? "ID" : "MY"
                      )), 1),
                      _createVNode("td", _hoisted_12, _toDisplayString(country.currencyCode) + " " + _toDisplayString(_ctx.formatItemPrice(
                        Number(country.maxPrice),
                        country.currencyCode === "IDR" ? "ID" : "MY"
                      )), 1),
                      _createVNode("td", _hoisted_13, _toDisplayString(country.currencyCode) + " " + _toDisplayString(_ctx.formatItemPrice(
                        Number(country.minCodFee),
                        country.currencyCode === "IDR" ? "ID" : "MY"
                      )), 1),
                      _createVNode("td", _hoisted_14, _toDisplayString(country.posDeliveryCommissionPercentage) + "% ", 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_DataWrapper, {
          fontStyleLabel: "font-normal text-black-lp-100",
          label: "Status Konfigurasi COD"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ChipsV2, {
              class: "mt-1",
              label: _ctx.detailData.ccoStatus,
              boldText: false
            }, null, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("span", _hoisted_18, _toDisplayString(_ctx.convertCreatedAt), 1),
          _createVNode("span", _hoisted_19, _toDisplayString(_ctx.detailData.ccoCreatedBy), 1)
        ]),
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode("span", _hoisted_22, _toDisplayString(_ctx.convertUpdatedAt), 1),
          _createVNode("span", _hoisted_23, _toDisplayString(_ctx.detailData.ccoUpdatedBy), 1)
        ]),
        (_ctx.isEditAble && !_ctx.isSenderAcount)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              customClass: "px-1 sm:px-12 py-2.5 text-red-lp-100",
              outline: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToEdit(_ctx.$route.params.id))),
              title: "Ubah",
              isWidthFull: "",
              iconLeft: "ics_o_edit_red"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}